import { apiFetch } from "./client";
import { adaptAnnotation, toAnnotationPayload } from "./adapters";

export const listAnnotations = async (caseId) =>
  (await apiFetch(`/api/cases/${caseId}/annotations`)).map(adaptAnnotation);

export const createAnnotation = async (caseId, modalityKey, anno) =>
  adaptAnnotation(
    await apiFetch(`/api/cases/${caseId}/annotations`, {
      method: "POST",
      body: toAnnotationPayload(modalityKey, anno),
    })
  );

export const updateAnnotation = async (annotationId, modalityKey, anno) =>
  adaptAnnotation(
    await apiFetch(`/api/annotations/${annotationId}`, {
      method: "PUT",
      body: toAnnotationPayload(modalityKey, anno),
    })
  );

export const deleteAnnotation = (annotationId) =>
  apiFetch(`/api/annotations/${annotationId}`, { method: "DELETE" });
